import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `AlbaranManual/filtrarAlbaranes`, method: 'POST', body: values, token: token})
}
